import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from '../components/desktop/LoadingScreen';

export default function ProfileRedirect() {
  const navigate = useNavigate();
  const { user, loading, setShowLoginModal } = useAuth();

  useEffect(() => {
    if (loading) return;

    if (user) {
      navigate(`/u/${user.username}`, { replace: true });
    } else {
      // Show login modal instead of redirecting
      setShowLoginModal(true);
    }
  }, [user, loading, navigate, setShowLoginModal]);

  if (!user && !loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--app-bg)' }}>
        <div className="text-center" style={{ color: 'var(--text-color)' }}>
          <h2 className="text-2xl font-bold mb-4">Sign in to view your profile</h2>
          <button
            onClick={() => setShowLoginModal(true)}
            className="px-6 py-3 rounded-lg font-semibold transition-opacity hover:opacity-90"
            style={{ backgroundColor: 'var(--accent-color, #06b6d4)', color: '#fff' }}
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  return <LoadingScreen />;
}
